import axios from './http';
import { SearchProcedureResultWrapper, SearchProceduresRequest } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/search-procedures`;

export const searchForProcedures = (searchProceduresRequest: Partial<SearchProceduresRequest>,
                                    source: CancelTokenSource): Promise<SearchProcedureResultWrapper> => {
  return axios
      .post(apiUri, searchProceduresRequest, { cancelToken: source.token})
      .then(response => response.data);
};

export const clearProceduresSearchCache = (searchId: string, source: CancelTokenSource): Promise<string> => {
  return axios
      .delete(`${apiUri}/clear-cache/${searchId}`, { cancelToken: source.token })
      .then(response => response.data);
};
